/**
 * Pre-compiled es messages for RichTextInput
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  bold: `Negrita`,
  bulletedList: `Lista no numerada`,
  code: `Código`,
  headingFive: `Encabezamiento 5`,
  headingFour: `Encabezamiento 4`,
  headingOne: `Encabezamiento 1`,
  headingThree: `Encabezamiento 3`,
  headingTwo: `Encabezamiento 2`,
  italic: `Cursiva`,
  listFormatting: `Formatear lista`,
  moreFormattingOptions: `Más opciones de formato`,
  moreStyles: `Más estilos`,
  numberedList: `Lista numerada`,
  paragraph: `Párrafo`,
  quote: `Presupuesto`,
  redo: `Repetir`,
  strikethrough: `Tachado`,
  subscript: `Subíndice`,
  superscript: `Índice superior`,
  textFormatting: `Formatear texto`,
  textStyle: `Estilo de texto`,
  textStyleMenu: `Menú de estilo de texto`,
  underline: `Subrayar`,
  undo: `Deshacer`,
};
